import { NavLink } from 'react-router-dom';

import { Disclosure } from '@headlessui/react';
import { 
        MenuIcon, 
        XIcon,
        DuplicateIcon,
        HeartIcon
} from '@heroicons/react/outline';

//logo
// import logo from '../../../../../../images/Bound_small_logo.png';

const NavbarProjects = ({allDesk, allMob, copiedDesk, copiedMob, likedDesk, likedMob}) => {

  const navlinkStyle = {textDecoration: 'none'}
  return (
    <Disclosure as="nav" className="bg-white shadow">
      {({ open }) => (
        <>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between h-16">
              <div className="flex">
                <div className="flex-shrink-0 flex items-center">
                    {/* <img
                    className="block lg:hidden h-8 w-auto"
                    src={logo}
                    alt="Bound"
                    />
                    <img
                    className="hidden lg:block h-8 w-auto"
                    src={logo}
                    alt="Bound"
                    /> */}
                </div>
                <div className="hidden sm:flex sm:space-x-8">
                  {/* Current: "border-indigo-500 text-gray-900", Default: "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700" */}
                    <NavLink
                    style={navlinkStyle}
                    exact
                    to={'/allProjects'}
                    className={allDesk}
                    >
                        All
                    </NavLink>
                    <NavLink
                    style={navlinkStyle}
                    exact
                    to={'/copiedProjects'}
                    className={copiedDesk}
                    >
                        <DuplicateIcon className="h-4 mr-1"/>Copied
                    </NavLink>
                    <NavLink
                    style={navlinkStyle}
                    exact
                    to={'/likedProjects'}
                    className={likedDesk}
                    >
                        <HeartIcon className="h-4 mr-1" />Saved
                    </NavLink>
                </div>
              </div>
              <div className="hidden sm:ml-6 sm:flex sm:items-center">
              </div>
              <div className="-mr-2 flex items-center sm:hidden">
                {/* Mobile menu button */}
                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="pt-2 pb-3 space-y-1">
              {/* Current: "bg-indigo-50 border-indigo-500 text-indigo-700", Default: "border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700" */}
                <NavLink
                style={navlinkStyle}
                exact
                to={'/allProjects'}
                className={allMob}
                >
                    All
                </NavLink>
                <NavLink
                style={navlinkStyle}
                exact
                to={'/copiedProjects'}
                className={copiedMob}                
                >
                    Copied
                </NavLink>
                <NavLink
                style={navlinkStyle}
                exact
                to={'/likedProjects'}
                className={likedMob}
                >
                    Saved
                </NavLink>
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  )
}

export default NavbarProjects